<!-- CONSULTAS → CUENTAS CT (CCP-03..09). Lo recibido en cuentas CT por rango, lo entregado y lo que debe quedar. Todo viene calculado del núcleo. -->
<div class="flex flex-col gap-[20px] min-w-0" [attr.aria-busy]="!r && !error">

  <section class="kb-card">
    <div class="kb-card-header">
      <div>
        <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-university text-muted-foreground" aria-hidden="true"></i>Cuentas CT</h2>
        <p class="kb-card-desc">Lo que entró a las cuentas de CrediTotal, lo que se entregó y lo que debe quedar. Solo lectura; el día de hoy no entra (el tope es ayer).</p>
      </div>
    </div>
    <div class="flex flex-col gap-[16px] px-[24px] py-[20px]">
      <div class="flex flex-col sm:flex-row sm:flex-wrap sm:items-end gap-3">
        <label class="kb-label" for="ctDesde">Desde
          <input type="date" class="kb-input sm:!w-[170px]" id="ctDesde" [(ngModel)]="f.desde" [max]="f.hasta || ayer" (change)="cambiarFiltro('desde')">
        </label>
        <label class="kb-label" for="ctHasta">Hasta
          <input type="date" class="kb-input sm:!w-[170px]" id="ctHasta" [(ngModel)]="f.hasta" [max]="ayer" (change)="cambiarFiltro('hasta')">
        </label>
        <label class="kb-label" for="ctComercio">Comercio
          <select class="kb-select sm:!w-[220px]" id="ctComercio" [(ngModel)]="f.comercio" (change)="cambiarFiltro()">
            <option value="Todos">Todos</option>
            <option *ngFor="let c of comercios" [value]="c">{{ c }}</option>
          </select>
        </label>
        <div class="flex flex-col sm:flex-row gap-2 sm:ml-auto">
          <button type="button" class="kb-btn kb-btn-outline" [disabled]="bajando.excel || !r" (click)="bajarExcel()"><i class="fas fa-file-excel" aria-hidden="true"></i>Bajar Excel</button>
          <button type="button" class="kb-btn kb-btn-outline" [disabled]="bajando.pdf || !r" (click)="bajarPdf()"><i class="fas fa-file-pdf" aria-hidden="true"></i>Bajar PDF</button>
        </div>
      </div>
      <p class="kb-hint m-0" *ngIf="avisoFecha" role="status">{{ avisoFecha }}</p>
      <p class="kb-hint m-0" *ngIf="r">
        <ng-container *ngIf="cierres">Cierres incluidos: {{ cierres }} · </ng-container>
        <ng-container *ngIf="r.foto_en">fotos diarias; la más antigua del {{ r.foto_en | date:'dd/MM/yy HH:mm' }}.</ng-container>
        <ng-container *ngIf="!r.foto_en">todavía sin fotos guardadas en este rango.</ng-container>
      </p>
      <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
        <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div>
      </div>
    </div>
  </section>

  <!-- Avance: informa, no bloquea -->
  <div class="kb-aviso kb-aviso-info" *ngIf="r?.preparando" role="status">
    <i class="fas fa-circle-notch fa-spin mt-0.5" aria-hidden="true"></i>
    <div><p class="m-0"><strong>Preparando {{ r.preparando.listos }} de {{ r.preparando.total }} días.</strong> Mientras tanto ves lo que ya está listo; esta pantalla se actualiza sola.</p></div>
  </div>
  <div class="kb-aviso kb-aviso-info" *ngFor="let a of r?.avisos" role="note">
    <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ a }}</p></div>
  </div>
  <div class="kb-aviso kb-aviso-info" *ngIf="r && f.comercio !== 'Todos'" role="note">
    <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
    <div><p class="m-0"><strong>«Sin aplicar» no pertenece a ningún comercio: no entra aquí.</strong> Se ve solo con «Todos», en su propia fila.</p></div>
  </div>

  <div class="kb-empty" *ngIf="r && !error && !hayRecibido && !r.preparando">
    <span class="kb-empty-icono"><i class="fas fa-inbox" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No entró dinero a cuentas CT en ese rango</p>
    <p class="kb-empty-texto">Prueba con otro rango de fechas o con todos los comercios.</p>
  </div>

  <!-- Tarjetas -->
  <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" aria-label="Resumen" *ngIf="r; else skTarjetas">
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0">
      <span class="text-sm text-muted-foreground">Recibido</span>
      <span class="text-[26px] font-bold tabular-nums text-foreground break-words">{{ fb(r.resumen.recibido.bs) }}</span>
      <span class="text-xs text-muted-foreground tabular-nums">{{ fu(r.resumen.recibido.usd) }} · {{ nn(r.resumen.recibido.n) }} {{ f.comercio === 'Todos' ? 'pagos' : 'abonos' }}</span>
    </div>
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0">
      <span class="text-sm text-muted-foreground">Entregado</span>
      <span class="text-[26px] font-bold tabular-nums text-foreground break-words">{{ fb(r.entregado?.bs) }}</span>
      <span class="text-xs text-muted-foreground tabular-nums">{{ r.entregado ? (fu(r.entregado.usd) + ' · ' + nn(r.entregado.lotes) + ' lotes') : 'Aún no disponible para este rango' }}</span>
    </div>
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0 !border-2 !border-foreground">
      <span class="text-sm text-muted-foreground">Debe quedar en cuentas</span>
      <span class="text-[26px] font-bold tabular-nums text-foreground break-words">{{ fb(r.composicion?.debe_quedar?.bs) }}</span>
      <span class="text-xs text-muted-foreground tabular-nums">{{ r.composicion ? fu(r.composicion.debe_quedar.usd) : 'Aún no disponible para este rango' }}</span>
    </div>
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0 !bg-emerald-50 !border-emerald-200 dark:!bg-emerald-500/10 dark:!border-emerald-500/30">
      <span class="text-sm font-medium text-emerald-800 dark:text-emerald-300">Utilidad</span>
      <span class="text-[26px] font-bold tabular-nums text-emerald-900 dark:text-emerald-200 break-words">{{ fb(r.resumen.utilidad.bs) }}</span>
      <span class="text-xs text-emerald-800 dark:text-emerald-300 tabular-nums">{{ fu(r.resumen.utilidad.usd) }} · margen {{ pc(r.resumen.utilidad.margen_pct) }}</span>
    </div>
  </section>

  <ng-container *ngIf="r; else skResto">
  <p class="kb-hint m-0" *ngIf="r.por_conciliar || r.fallidos">Aparte, no suman a lo recibido:
    <ng-container *ngIf="r.por_conciliar">por conciliar {{ fb(r.por_conciliar.bs) }} ({{ fu(r.por_conciliar.usd) }}, {{ nn(r.por_conciliar.n) }} pagos)</ng-container><ng-container *ngIf="r.por_conciliar && r.fallidos"> · </ng-container>
    <ng-container *ngIf="r.fallidos">fallidos o anulados {{ fb(r.fallidos.bs) }} ({{ fu(r.fallidos.usd) }}, {{ nn(r.fallidos.n) }} pagos)</ng-container>.</p>
  <ng-container *ngIf="hayRecibido">

    <!-- Composición de lo que debe quedar -->
    <section class="kb-card min-w-0" *ngIf="r.composicion">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Por qué debe quedar ese dinero</h2>
        <p class="kb-card-desc">Lo recibido menos lo entregado se explica con estas partidas. Barra rayada: resta.</p>
      </div></div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Partida</th><th class="kb-th kb-th-num">Bs</th><th class="kb-th kb-th-num">USD</th><th class="kb-th min-w-[140px]">Proporción</th></tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let p of r.composicion.partidas">
              <td class="kb-td">{{ p.nombre }}</td>
              <td class="kb-td kb-td-num">{{ fb(p.bs) }}</td>
              <td class="kb-td kb-td-num">{{ fu(p.usd) }}</td>
              <td class="kb-td"><span class="block h-2.5 rounded-sm" [style.width.%]="ancho(p.bs)" [ngClass]="p.bs < 0 ? 'bg-[repeating-linear-gradient(45deg,#94a3b8_0_4px,#cbd5e1_4px_8px)]' : 'bg-[#2a78d6]'"></span></td>
            </tr>
            <tr class="kb-tr" *ngIf="hayDiferencia()">
              <td class="kb-td">Diferencia sin explicar<span class="kb-td-sub block">Se muestra, no se ajusta: se explica pago por pago.</span></td>
              <td class="kb-td kb-td-num">{{ fb(r.composicion.diferencia.bs) }}</td><td class="kb-td kb-td-num">{{ fu(r.composicion.diferencia.usd) }}</td><td class="kb-td"></td>
            </tr>
            <tr class="kb-tr">
              <td class="kb-td font-semibold">Debe quedar en cuentas</td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(r.composicion.debe_quedar.bs) }}</td><td class="kb-td kb-td-num font-semibold">{{ fu(r.composicion.debe_quedar.usd) }}</td><td class="kb-td"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="kb-card min-w-0" *ngIf="!r.composicion && r.composicion_nota">
      <div class="kb-card-header"><h2 class="kb-card-title">Por qué debe quedar ese dinero</h2></div>
      <div class="px-[24px] py-[20px]"><p class="kb-hint m-0">{{ r.composicion_nota }}</p></div>
    </section>

    <!-- Por banco y día -->
    <section class="kb-card min-w-0">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Por banco y día</h2>
        <p class="kb-card-desc">Bolívares conciliados, por fecha del pago. Pasa el cursor sobre una barra para ver el detalle.</p>
      </div></div>
      <div class="flex flex-col gap-3 px-[24px] py-[20px] min-w-0">
        <div class="flex flex-wrap gap-x-5 gap-y-2 text-sm text-muted-foreground">
          <span *ngFor="let k of bancos" class="inline-flex items-center gap-2"><span class="inline-block h-3 w-3 rounded-sm" [style.background]="k.color"></span>{{ k.nombre }}</span>
        </div>
        <div class="overflow-x-auto min-w-0">
          <div class="min-w-[720px]">
            <svg viewBox="0 0 1240 300" width="100%" role="img" class="block" aria-label="Bolívares recibidos por día y banco">
              <g *ngFor="let e of ejeY">
                <line x1="64" x2="1228" [attr.y1]="e.y" [attr.y2]="e.y" stroke="#e4e3df"></line>
                <text x="56" [attr.y]="e.y + 4" text-anchor="end" font-size="11" fill="#52514e">{{ e.texto }}</text>
              </g>
              <g *ngFor="let b of barras">
                <title>{{ b.titulo }}</title>
                <rect class="cursor-pointer" [attr.x]="b.x" [attr.y]="b.y" [attr.width]="b.w" [attr.height]="b.h" rx="3" [attr.fill]="b.color" (mousemove)="verTip($event, b)" (mouseleave)="quitarTip()"></rect>
                <text *ngIf="b.etiqueta" [attr.x]="b.xc" [attr.y]="b.yc" text-anchor="middle" font-size="11" font-weight="600" fill="#fff" pointer-events="none">{{ b.etiqueta }}</text>
              </g>
              <text *ngFor="let t of totales" [attr.x]="t.xc" [attr.y]="t.yc" text-anchor="middle" font-size="12" font-weight="700" fill="#0b0b0b">{{ t.etiqueta }}</text>
              <text *ngFor="let e of ejeX" [attr.x]="e.x" y="288" text-anchor="middle" font-size="11" fill="#52514e">{{ e.texto }}</text>
            </svg>
          </div>
        </div>
        <div *ngIf="tip" class="fixed z-[80] pointer-events-none rounded-md bg-foreground px-2.5 py-1.5 text-xs leading-snug text-background max-w-[260px]" [style.left.px]="tip.x" [style.top.px]="tip.y" role="tooltip">
          <div>{{ tip.titulo }}</div><div class="font-bold" *ngFor="let l of tip.lineas">{{ l }}</div>
        </div>
      </div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Día</th><th class="kb-th kb-th-num" *ngFor="let k of bancos">{{ k.nombre }}</th><th class="kb-th kb-th-num">Total</th></tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let d of diasGrafico">
              <td class="kb-td whitespace-nowrap tabular-nums">{{ d.etiqueta }}</td>
              <td class="kb-td kb-td-num" *ngFor="let c of d.celdas">{{ c.bs === null ? '—' : fb(c.bs) }}<span class="kb-td-sub block" *ngIf="c.bs !== null">{{ fu(c.usd) }}</span></td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(d.total) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Por cuenta -->
    <section class="kb-card min-w-0">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Por cuenta bancaria</h2>
        <p class="kb-card-desc">Cada cuenta de CT que recibió pagos conciliados en el rango.</p>
      </div></div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Cuenta</th><th class="kb-th kb-th-num">Pagos</th><th class="kb-th kb-th-num">Recibido</th><th class="kb-th min-w-[140px]">Parte del total</th></tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let c of r.por_cuenta">
              <td class="kb-td"><span class="inline-block h-2 w-2 rounded-sm mr-2" [style.background]="colorDe(c.banco)"></span>{{ c.nombre }}<span class="kb-td-sub block">{{ c.banco }}</span></td>
              <td class="kb-td kb-td-num">{{ nn(c.n) }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(c.bs) }}<span class="kb-td-sub block">{{ fu(c.usd) }}</span></td>
              <td class="kb-td"><span class="block h-2.5 rounded-sm" [style.width.%]="c.pct" [style.min-width.px]="2" [style.background]="colorDe(c.banco)"></span><span class="kb-td-sub block">{{ pc(c.pct) }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Comparar comercios -->
    <section class="kb-card min-w-0" *ngIf="r.comparar?.length">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Comparar comercios</h2>
        <p class="kb-card-desc">Con «Todos», cada comercio en su fila. La suma de los comercios más «Sin aplicar» da el recibido de Todos.</p>
      </div></div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Comercio</th><th class="kb-th kb-th-num">Recibido</th><th class="kb-th kb-th-num">A cuotas</th><th class="kb-th kb-th-num">Fees</th><th class="kb-th kb-th-num">Utilidad</th><th class="kb-th kb-th-num">Margen</th></tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let c of r.comparar">
              <td class="kb-td">{{ c.comercio }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(c.recibido_bs) }}<span class="kb-td-sub block">{{ fu(c.recibido_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ fu(c.cuotas_usd) }}</td>
              <td class="kb-td kb-td-num">{{ fu(c.fees_usd) }}</td>
              <td class="kb-td kb-td-num font-semibold">{{ fb(c.utilidad_bs) }}<span class="kb-td-sub block">{{ fu(c.utilidad_usd) }}</span></td>
              <td class="kb-td kb-td-num">{{ pc(c.margen_pct) }}</td>
            </tr>
            <tr class="kb-tr" *ngIf="r.resumen.sin_aplicar">
              <td class="kb-td">Sin aplicar<span class="kb-td-sub block">No pertenece a ningún comercio</span></td>
              <td class="kb-td kb-td-num">{{ fb(r.resumen.sin_aplicar.bs) }}<span class="kb-td-sub block">{{ fu(r.resumen.sin_aplicar.usd) }}</span></td>
              <td class="kb-td kb-td-num">—</td><td class="kb-td kb-td-num">—</td><td class="kb-td kb-td-num">—</td><td class="kb-td kb-td-num">—</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Neteos -->
    <section class="kb-card min-w-0" *ngIf="r.neteos">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Neteos: cierres sin dinero</h2>
        <p class="kb-card-desc">Cuotas que se cerraron sin que entrara dinero.</p>
      </div></div>
      <div class="flex flex-col gap-3 px-[24px] py-[20px]">
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div><div class="text-[26px] font-bold tabular-nums">{{ nn(r.neteos.total.n) }}</div><div class="kb-hint">neteos</div></div>
          <div><div class="text-[26px] font-bold tabular-nums break-words">{{ fb(r.neteos.total.bs) }}</div><div class="kb-hint">{{ fu(r.neteos.total.usd) }}</div></div>
          <div class="flex items-start"><span class="kb-badge kb-badge-neutro">Los asume CT</span></div>
        </div>
        <div class="kb-cinta" role="note">
          <i class="fas fa-info-circle kb-cinta-icono" aria-hidden="true"></i>
          <span>{{ r.neteos.nota }}</span>
        </div>
      </div>
      <div class="kb-table-envoltorio">
        <table class="kb-table">
          <thead class="kb-thead"><tr><th class="kb-th">Día</th><th class="kb-th kb-th-num">Neteos</th><th class="kb-th kb-th-num">Bs</th><th class="kb-th kb-th-num">USD</th></tr></thead>
          <tbody>
            <tr class="kb-tr" *ngFor="let d of r.neteos.por_dia">
              <td class="kb-td tabular-nums whitespace-nowrap">{{ corto(d.dia) }}</td><td class="kb-td kb-td-num">{{ nn(d.n) }}</td><td class="kb-td kb-td-num">{{ fb(d.bs) }}</td><td class="kb-td kb-td-num">{{ fu(d.usd) }}</td>
            </tr>
            <tr class="kb-tr">
              <td class="kb-td font-semibold">Total</td><td class="kb-td kb-td-num font-semibold">{{ nn(r.neteos.total.n) }}</td><td class="kb-td kb-td-num font-semibold">{{ fb(r.neteos.total.bs) }}</td><td class="kb-td kb-td-num font-semibold">{{ fu(r.neteos.total.usd) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- Comprobaciones -->
    <section class="kb-card min-w-0" *ngIf="r.comprobaciones?.length">
      <div class="kb-card-header"><div>
        <h2 class="kb-card-title">Comprobaciones</h2>
        <p class="kb-card-desc">Revisión automática de la liquidación en el rango.</p>
      </div></div>
      <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3 px-[24px] py-[20px]">
        <div class="flex items-start gap-3 rounded-[10px] border border-border p-3 min-w-0" *ngFor="let c of r.comprobaciones">
          <span class="flex h-8 w-8 flex-none items-center justify-center rounded-full" [ngClass]="c.ok === true ? 'bg-emerald-100 text-emerald-800' : c.ok === false ? 'bg-amber-100 text-amber-800' : 'bg-muted text-muted-foreground'">
            <i class="fas" [ngClass]="c.ok === true ? 'fa-check' : c.ok === false ? 'fa-eye' : 'fa-clock'" aria-hidden="true"></i>
          </span>
          <div class="min-w-0">
            <div class="text-xl font-bold tabular-nums break-words">{{ c.ok === null ? '—' : valorComprobacion(c) }}</div>
            <div class="text-sm font-medium">{{ c.nombre }}</div>
            <div class="kb-hint">{{ c.nota || (c.ok === true ? 'Sin nada que mirar' : c.ok === false ? 'Para revisar' : 'Se calcula al cerrar el cierre') }}</div>
          </div>
        </div>
      </div>
    </section>

    <div class="kb-cinta kb-cinta-info" role="note">
      <i class="fas fa-info-circle kb-cinta-icono" aria-hidden="true"></i>
      <span>Recibido es por pagos conciliados y fecha del pago. La pestaña Utilidad cuenta por fecha de registro e incluye lo no conciliado, por eso sus cifras difieren.</span>
    </div>
  </ng-container>
  </ng-container>
</div>

<!-- ══ Cuadros grises: la misma forma que lo real, para que nada salte al llegar los datos ══ -->
<ng-template #skTarjetas>
  <section class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" aria-label="Cargando el resumen">
    <div class="kb-card p-[18px] flex flex-col gap-1.5 min-w-0" *ngFor="let i of esqueleto">
      <span class="kb-skeleton h-5 w-24"></span>
      <span class="kb-skeleton h-[39px] w-3/4"></span>
      <span class="kb-skeleton h-4 w-1/2"></span>
    </div>
  </section>
</ng-template>

<ng-template #skResto>
  <ng-container *ngTemplateOutlet="skTabla"></ng-container>
  <ng-container *ngTemplateOutlet="skGrafico"></ng-container>
  <ng-container *ngTemplateOutlet="skTabla"></ng-container>
  <ng-container *ngTemplateOutlet="skTabla"></ng-container>
</ng-template>

<ng-template #skTabla>
  <section class="kb-card min-w-0" aria-label="Cargando una tabla">
    <div class="kb-card-header"><div class="flex flex-col gap-2"><span class="kb-skeleton h-5 w-56"></span><span class="kb-skeleton h-4 w-80 max-w-full"></span></div></div>
    <div class="flex flex-col gap-3 px-[24px] py-[20px]">
      <span class="kb-skeleton h-10 w-full"></span>
      <span class="kb-skeleton h-8 w-full" *ngFor="let i of filasGris"></span>
    </div>
  </section>
</ng-template>

<ng-template #skGrafico>
  <section class="kb-card min-w-0" aria-label="Cargando el gráfico">
    <div class="kb-card-header"><div class="flex flex-col gap-2"><span class="kb-skeleton h-5 w-40"></span><span class="kb-skeleton h-4 w-96 max-w-full"></span></div></div>
    <div class="flex flex-col gap-3 px-[24px] py-[20px]">
      <div class="flex gap-4"><span class="kb-skeleton h-4 w-24"></span><span class="kb-skeleton h-4 w-24"></span><span class="kb-skeleton h-4 w-24"></span></div>
      <div class="kb-skeleton h-[300px] w-full"></div>
    </div>
  </section>
</ng-template>
